<template lang='pug'>
  b-modal(
    id='agent-installer-dialog'
    :title="$t('agent_installer_file')"
    size='lg'
    dialog-class="custom-modal-dialog"
    body-class="custom-modal-body"
    @hide='onHidden'
  )
    b-container(fluid)
      // 설명
      b-alert.alert-description(show, variant='info')
        span(v-html="$t('agent_file_description')")
      
      h6 {{$t('install_type')}}
      
      div.d-flex.justify-content-between(style="height: 28px;")
        b-form-radio-group.ml-3(
          v-model='form.installType'
          :options='installTypeOptions'
          name='installType'
        )
        
        div.mr-3(v-if='!isManualInstall')
          label.custom-checkbox
            input(type="checkbox", v-model="isTermsChecked")
            span.box
            span.label-text
              | ({{$t('required_label')}}) {{$t('agreement.agree_use')}}
              button.view-link(type="button", @click="openModal") {{$t('agreement_view_text')}}
      
      hr
      
      h6 {{$t('access_account_setting')}}
      
      // 아이디
      div.form-row.align-items-center.mb-3
        label.form-label.custom-label(for="id")
          | {{$t('ID')}}
          strong.text-danger *
        div.col
          b-form-input#id(
            size='sm'
            type="text",
            v-model="form.id",
            :placeholder="$t('ID')",
            :disabled="isManualInstall",
            @input="validateId",
          )
      
      // 비밀번호
      div.form-row.align-items-center.mb-3
        label.form-label.custom-label(for="password")
          | {{$t('PW')}}
          strong.text-danger *
        div.col
          b-form-input#password(
            size='sm'
            :type="showPw ? 'text' : 'password'",
            v-model="form.password",
            autocomplete="new-password",
            :placeholder="$t('enter_password')",
            :disabled="isManualInstall",
          )
          b-input-group-append(@click='toggleShowPw')
            icon(
              size='sm'
              :name="showPw ? 'eye-slash' : 'eye'",
              style="position: absolute; right: 1rem; top: 50%; transform: translateY(-50%); cursor: pointer;"
            )
      
      
      // 비밀번호 확인
      div.form-row.align-items-center
        label.form-label.custom-label(for="passwordConfirm")
          | {{$t('PW_confirm')}}
          strong.text-danger *
        div.col
          b-form-input#passwordConfirm(
            size='sm'
            :type="showPw ? 'text' : 'password'",
            v-model="form.passwordConfirm",
            autocomplete="new-password",
            :placeholder="$t('PW_confirm_desc')",
            :state="validates.pwConfirm",
            :disabled="isManualInstall",
            @input="validatePwConfirm",
          )
      
      hr
      
      h6 {{$t('access_permission_setting')}}
      // 설치파일 만료일
      div.form-row.align-items-center.mb-3
        label.form-label.custom-label(for="groupName")
          | {{$t('installer_file_expiration_date')}}
          strong.text-danger *
        div.col
          b-form-datepicker(
            size='sm'
            v-model='form.expireDate'
            :locale='datepickerLocale'
            :min="minDate"
            :placeholder="$t('select_expiration_date')"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            :disabled="isManualInstall",
          )
      
      hr
      
      h6 {{$t('proxy_server_setting')}}
      b-form-radio-group.mt-3.ml-3.mb-3(
        v-model='form.proxyType'
        :options='proxyTypeOptions'
        name='proxyType'
        :disabled="isManualInstall",
      )
      
      // 프록시 서버
      div.form-row.align-items-center
        label.form-label.custom-label(for="proxyServer")
          | {{$t('proxy_server')}}
          strong.text-danger
        div.col
          b-form-input#proxyServer(
            size='sm'
            type="text",
            v-model="form.proxyServer",
            :state="validates.proxyServer",
            :placeholder="$t('proxy_server')",
            :disabled="isManualInstall || isProxyDisabled || isAutoProxy",
            @input="() => validateProxyFields({ skipReset: true })"
          )
      
      // 프록시 포트
      div.form-row.align-items-center
        label.form-label.custom-label(for="proxyPort")
          | {{$t('proxy_port')}}
          strong.text-danger
        div.col
          b-form-input#proxyPort(
            size='sm'
            type="text",
            v-model="form.proxyPort",
            :state="validates.proxyPort",
            :placeholder="$t('proxy_port')",
            :disabled="isManualInstall || isProxyDisabled || isAutoProxy",
            @input="() => validateProxyFields({ skipReset: true })"
          )
      
      // 프록시 아이디
      div.form-row.align-items-center
        label.form-label.custom-label(for="proxyId")
          | {{$t('proxy_id')}}
        div.col
          b-form-input#proxyId(
            size='sm'
            type="text",
            v-model="form.proxyId",
            :placeholder="$t('proxy_id')",
            :disabled="isManualInstall || isProxyDisabled",
            @input="() => validateProxyFields({ skipReset: true })"
          )
      
      // 프록시 비밀번호
      div.form-row.align-items-center
        label.form-label.custom-label(for="proxyPassword")
          | {{$t('proxy_password')}}
        div.col
          b-form-input#proxyPassword(
            size='sm'
            type="text",
            v-model="form.proxyPassword",
            :placeholder="$t('proxy_password')",
            :disabled="isManualInstall || isProxyDisabled",
            @input="() => validateProxyFields({ skipReset: true })"
          )
    
    dialog-agreement(
      :modal-id='dialog.id'
      :title='dialog.title'
      :content='dialog.content'
    )
    
    // 커스텀 푸터
    template(v-slot:modal-footer)
      b-button(size='sm', variant="secondary", @click="$bvModal.hide('agent-installer-dialog')") {{$t('cancel')}}
      b-button(v-if="form.installType==='autoInstall'", size='sm', variant="primary", @click="createAgentFile", :disabled="!isFormValid") {{$t('generate_installer_file')}}
      b-button(v-else variant="primary", target="_blank", size='sm', :href="generateUrl(`${agent}/linkmeminese_windows_agent_setup.exe`)", download) {{$t('download')}}
</template>

<script>
import {login} from '@/api/access'
import DialogAgreement from '@/components/dialogs/dialogAgreement.vue'
import { store } from '@/api/store'

export default {
  name: 'AgentInstallerDialog',
  components: {DialogAgreement},
  data() {
    return {
      showPw: false,
      minDate: new Date().toISOString().slice(0, 10),
      agent: `${this.AppState.Path.download}/agent`,
      form: this.defaultForm(),
      validates: this.defaultValidates(),
      isTermsChecked: false,
      installTypeOptions: [
        {text: this.$t('auto_login_install_mode'), value: 'autoInstall'},
        // {text: this.$t('manual_login_install_mode'), value: 'manualInstall'},
      ],
      proxyTypeOptions: [
        {text: this.$t('disabled'), value: 'none'},
        {text: this.$t('manual_setting'), value: 'manual'},
        {text: this.$t('auto_setting'), value: 'auto'},
      ],
      dialog: {
        id: 'agreement-modal',
        title: '',
        content: '',
      },
    }
  },
  methods: {
    createAgentFile() {
      const payload = {
        installType: this.form.installType,
        expireDate: this.form.expireDate
            ? new Date(this.form.expireDate).toISOString().slice(0, 10)
            : null,
        proxyType: this.form.proxyType,
        proxyServer: this.form.proxyServer,
        proxyPort: this.form.proxyPort,
        proxyId: this.form.proxyId,
        proxyPassword: this.form.proxyPassword,
      }
      
      const networkType = store.get("networkType")
      let loginType = networkType.indexOf("i") === 0 ? 'manager' : 'user'
      
      const authData = {
        type: '1STEP',
        id: this.form.id,
        pw: this.form.password,
      }
      
      login(authData, (err, resp) => {
        if (resp) {
          payload.id = this.form.id
          payload.password = this.form.password

          this.$emit('confirmed', payload)
          this.$bvModal.hide('agent-installer-dialog')
        } else {
          this.$awn.warning(this.$t('login_failed_invalid_credentials'))
          this.$bvModal.hide('agent-installer-dialog')
        }
      })
    },
    onHidden() {
      this.showPw = false
      this.form = this.defaultForm()
      this.validates = this.defaultValidates()
      this.isTermsChecked = false
    },
    defaultForm() {
      return {
        installType: 'autoInstall',
        groupName: '',
        id: '',
        password: '',
        passwordConfirm: '',
        expireDate: null,
        proxyType: 'none',
        proxyServer: '',
        proxyPort: '',
        proxyId: '',
        proxyPassword: '',
      }
    },
    defaultValidates() {
      return {
        id: false,
        pwConfirm: false,
        proxyServer: true,
        proxyPort: true,
        proxyAuth: true,
      }
    },
    toggleShowPw() {
      this.showPw = !this.showPw
    },
    validateId() {
      this.validates.id = !!this.form.id && this.form.id.trim().length > 0
    },
    validatePwConfirm() {
      this.validates.pwConfirm = this.form.password === this.form.passwordConfirm
    },
    generateUrl(baseUrl) {
      return `${baseUrl}?timestamp=${new Date().getTime()}`
    },
    validateProxyFields({skipReset = false} = {}) {
      const isAutoInstall = this.form.installType === 'autoInstall'
      const proxyType = this.form.proxyType
      
      // 프록시 ID, PW 유효성 검사 -> 다 작성하거나 다 작성 안하거나
      this.validateProxyAuth()
      
      if (!isAutoInstall) {
        // 수동 로그인 설치면 무시
        this.resetAllProxyFields()
        return
      }
      
      if (proxyType === 'manual') {
        this.setManualProxy(skipReset)
      } else if (proxyType === 'auto') {
        this.setAutoProxy(skipReset)
      } else {
        this.resetAllProxyFields()
      }
    },
    validateProxyAuth() {
      const hasProxyId = !!this.form.proxyId.trim()
      const hasProxyPw = !!this.form.proxyPassword.trim()
      this.validates.proxyAuth = (!hasProxyId && !hasProxyPw) || (hasProxyId && hasProxyPw)
    },
    resetAllProxyFields() {
      this.validates.proxyServer = true
      this.validates.proxyPort = true
      this.validates.proxyAuth = true
      
      this.form.proxyServer = ''
      this.form.proxyPort = ''
      this.form.proxyId = ''
      this.form.proxyPassword = ''
    },
    setManualProxy(skipReset) {
      if (!skipReset) {
        this.resetAuthFields()
        this.form.proxyServer = ''
        this.form.proxyPort = ''
      }
      
      const {proxyServer, proxyPort} = this.form
      
      // IP 또는 도메인 형식 정규식
      const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/
      const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/
      
      // 프록시 서버 유효성: auto 제외 + 공백 제외 + IP or 도메인 형식만 허용
      this.validates.proxyServer = !!(
          proxyServer &&
          proxyServer !== 'auto' &&
          proxyServer.trim() &&
          (ipRegex.test(proxyServer.trim()) || domainRegex.test(proxyServer.trim()))
      )
      
      // 포트 유효성: auto 제외 + 공백 제외 + 숫자만 허용 + 1~65535 범위
      const portNum = parseInt(proxyPort, 10);
      this.validates.proxyPort = !!(
          proxyPort &&
          proxyPort !== 'auto' &&
          /^\d+$/.test(proxyPort.trim()) &&
          portNum >= 1 &&
          portNum <= 65535
      )
    },
    setAutoProxy(skipReset) {
      this.validates.proxyServer = true
      this.validates.proxyPort = true
      
      this.form.proxyServer = 'auto'
      this.form.proxyPort = 'auto'
      
      if (!skipReset) {
        this.resetAuthFields()
      }
    },
    resetAuthFields() {
      this.form.proxyId = ''
      this.form.proxyPassword = ''
    },
    openModal() {
      this.dialog.title = this.$t('agreement.agree_use')
      this.dialog.content = this.$t('agent_auto_login_agreement_text')
      this.$root.$emit('bv::show::modal', this.dialog.id)
    },
  },
  computed: {
    datepickerLocale() {
      return String(this.$i18n.locale)
    },
    isProxyDisabled() {
      return this.form.proxyType === 'none'
    },
    isManualInstall() {
      return this.form.installType === 'manualInstall'
    },
    isAutoProxy() {
      return this.form.proxyType === 'auto'
    },
    isFormValid() {
      const f = this.form
      const v = this.validates
      
      return (
          v.id &&
          v.pwConfirm &&
          f.expireDate &&
          v.proxyServer &&
          v.proxyPort &&
          v.proxyAuth &&
          this.isTermsChecked
      )
    },
  },
  watch: {
    'form.proxyType': 'validateProxyFields',
    'form.installType': 'validateProxyFields',
  },
}
</script>

<style scoped lang="scss">

::v-deep .modal-header {
  font-size: 13px;
  
  button {
    color: black;
  }
}

/* 모달 외곽 높이 제한 */
::v-deep .custom-modal-dialog {
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}

/* 모달 본문 내부만 스크롤 */
::v-deep .custom-modal-body {
  overflow-y: auto;
  max-height: calc(100vh - 200px);
  padding-right: 12px;
}

.form-row {
  margin-bottom: 1rem;
  
  > label {
    padding-left: 15px;
    font-size: 15px;
    
    > strong {
      margin-left: 5px;
    }
  }
  
}

.custom-label {
  flex: 0 0 18.6667%;
  max-width: 18.6667%;
  margin-bottom: 0;
  
  @media (max-width: 993px) {
    flex: 0 0 33.3333%;
    max-width: 35.3333%;
  }
}

.alert-description {
  font-size: 12px;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  width: fit-content;
  
  .view-link {
    margin-left: 0.5rem;
    color: #2563eb;
    text-decoration: underline;
    font-size: 12px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
  }
  
  @media (max-width: 768px) {
    font-size: 10px;
    
    .view-link {
      font-size: 10px;
    }
  }
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

/* 체크박스 박스 디자인 */
.custom-checkbox .box {
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 6px;
  margin-right: 0.75rem;
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s;
  transform: scale(0.8);
}

/* 체크 상태일 때 박스 스타일 변경 */
.custom-checkbox input[type="checkbox"]:checked + .box {
  background-color: #2563eb;
  border-color: #2563eb;
}

/* 체크 마크 스타일 */
.custom-checkbox input[type="checkbox"]:checked + .box::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

::v-deep .custom-control-label span {
  font-size: 15px !important;
}
</style>